import { useProfileByKeycloakId } from "@/api/auth";
import { Badge } from "@/components/ui/badge";
import { DownloadButton } from "@/components/ui/button";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { getBadgeVariant } from "@/utils/helper/getBadgeVariant";
import { useRFSDownload } from "./hooks/useRFSDownload";

export default function RFSStatisticDownloadSection({
  selectedPICLinknets,
  selectedPICVendors,
  selectedTenantNames,
  selectedVendorNames,
  selectedDateMonthYear,
  isVendor,
  companyCode,
}: {
  selectedPICLinknets: string;
  selectedPICVendors: string;
  selectedTenantNames: string;
  selectedVendorNames: string;
  selectedDateMonthYear: string;
  isVendor: boolean;
  companyCode?: string;
}) {
  const { id: keycloakId } = useCurrentUser();
  const { data: user } = useProfileByKeycloakId({ keycloakId: keycloakId });

  const { status, isExporting, handleExport } = useRFSDownload({
    selectedPICLinknets,
    selectedPICVendors,
    selectedTenantNames,
    selectedVendorNames,
    selectedDateMonthYear,
    isVendor,
    companyCode,
    userId: user?.id,
  });

  return (
    <div className="flex gap-x-2">
      <div className="flex items-center">
        <Badge variant={getBadgeVariant(isExporting ? "IN PROGRESS" : status)}>
          {isExporting ? "IN PROGRESS" : status}
        </Badge>
      </div>
      <DownloadButton onClick={handleExport} loading={isExporting} />
    </div>
  );
}
